<template>
    <section
        ref="section"
        :class="['slice', 'slice-video', variationModifier, {'slice-video--hide-in-mobile': primary.hideInMobile}]"
        data-testid="video-slice"
        aria-label="video"
    >
        <div class="slice-content">
            <PrismicRichText :field="primary.title" class="slice-title" />
            <PrismicRichText :field="primary.subtitle" class="slice-subtitle" />
            <PrismicRichText :field="primary.description" class="slice-description" />
            <PrismicLink v-if="isFilled.link(primary.link)" :field="primary.link" class="link slice-video__link" data-component-source="video" />
            <div class="slice-video__grid" :class="{'slice-video__grid--multiple': videoPlayers.length > 1}">
                <MktVideoPlayer v-for="(video, i) in videoPlayers" v-bind="video" :key="i" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import type {LinkField, RichTextField} from '@prismicio/types';
    import {PrismicLink, PrismicRichText} from '@prismicio/vue';
    import {MktVideoPlayer} from '#components';
    import {useComponentTracking} from '#imports';
    import type {VideoPlayerProps} from '../../composables/useVideoEmbedPlayer';

    export type VideoVariationPrimary = {
        title: RichTextField;
        subtitle: RichTextField;
        description: RichTextField;
        link: LinkField;
        hideInMobile: boolean | null;
    };

    defineProps<{
        variationModifier: string;
        primary: VideoVariationPrimary;
        videoPlayers: VideoPlayerProps[];
    }>();

    const section = useTemplateRef('section');
    useComponentTracking(section);
</script>
